// Constants for different requests for current reducer
export default {
  pageStore: 'pageStore',
};
